// extracted by mini-css-extract-plugin
var _1 = "TopicView-module__animatedBackground--mlrfW";
var _2 = "TopicView-module__container--CNtlH";
var _3 = "TopicView-module__isEditing--mp646";
export { _1 as "animatedBackground", _2 as "container", _3 as "isEditing" }
